export default __webpack_public_path__ + "static/media/demo-2.a6c3fc6d.png";